import {connect} from 'react-redux';
import {Graphics as Component} from './Graphics';
import { hideAllControls, setSolutionInScene, setModal, showModal, pushInteractions, waterBathOpen, 
  waterBathContainsTubeRack, tubeInWaterBath,toggleToolTipControlsForWaterBath
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("waterBath") &&
     state.notebook.protocolSection.scene.apparatus.waterBath.some(
       waterBath => waterBath.id === ownProps.id
     )
  ){
 return {

      id: ownProps.id,
      open: state.notebook.protocolSection.scene.apparatus.waterBath[ownProps.id - 1].open,
      temp: state.notebook.protocolSection.scene.apparatus.waterBath[ownProps.id - 1].temp,
      timeSet: state.notebook.protocolSection.scene.apparatus.waterBath[ownProps.id - 1].timeSet,
      timeLeft: state.notebook.protocolSection.scene.apparatus.waterBath[ownProps.id - 1].timeLeft,
      hasRack: state.notebook.protocolSection.scene.apparatus.waterBath[ownProps.id - 1].containsTubeRack,
      showToolTipControls: state.notebook.protocolSection.scene.apparatus.waterBath[ownProps.id - 1].showToolTipControls,
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {

    hideAllControls: (data) => {
      dispatch(hideAllControls(data))
    },
    waterBathOpen: (data) => {
      dispatch(waterBathOpen(data))
    }, 
    waterBathContainsTubeRack: (data) => {
      dispatch(waterBathContainsTubeRack(data))
    }, 
    tubeInWaterBath: (data) => {
      dispatch(tubeInWaterBath(data))
    }, 
    setSolutionInScene: (data) => {
      dispatch(setSolutionInScene(data))
    }, 
    setModal: (data) => {
      dispatch(setModal(data))
    }, 
    showModal: (data) => {
      dispatch(showModal(data))
    },

    pushInteractions: (data) =>{
      dispatch(pushInteractions(data))
    },
    toggleToolTipControlsForWaterBath: (data) =>{
      dispatch(toggleToolTipControlsForWaterBath(data))
    },

    

  };
}

export const Graphics = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
